"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayPointDetailsPage = void 0;
var react_1 = __importStar(require("react"));
var doshx_controls_web_1 = require("doshx_controls_web");
var page_path_1 = require("../components/page_path");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var update_advanced_user_details_1 = require("../../../api/calls/user/update_advanced_user_details");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var main_1 = require("../../../reducers/slices/main");
var get_user_details_1 = require("../../../api/calls/user/get_user_details");
var functions_1 = require("../../../constants/functions");
var PayPointDetailsPage = function () {
    var _a;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _b = (0, react_1.useState)({
        phone_number: "",
        country_code: "+267",
        country_abbreviation: "BW",
    }), payPointPhoneNumber = _b[0], setPayPointPhoneNumber = _b[1];
    var _c = (0, react_1.useState)(""), payPointPostalAddress = _c[0], setPoayPointPostalAdddress = _c[1];
    var _d = (0, react_1.useState)(""), postalCode = _d[0], setPostalCode = _d[1];
    var _e = (0, react_1.useState)(""), payPointPhysicalAddress = _e[0], setSpouseHomeNumber = _e[1];
    var _f = (0, react_1.useState)(""), payMaster = _f[0], setPaymaster = _f[1];
    var _g = (0, react_1.useState)(""), payPointPhoneNumberMessage = _g[0], setPayPointPhoneNumberMessage = _g[1];
    var _h = (0, react_1.useState)(""), payPointPostalAddressMessage = _h[0], setSpouseSurnameMessage = _h[1];
    var _j = (0, react_1.useState)(""), postalCodeMessage = _j[0], setSpouseCellNumberMessage = _j[1];
    var _k = (0, react_1.useState)(""), payPointPhysicalAddressMessage = _k[0], setPayPointPhysicalAddressMessage = _k[1];
    var _l = (0, react_1.useState)(""), payMasterMessage = _l[0], setPaymasterMessage = _l[1];
    //
    var _m = (0, react_1.useState)(false), isSaving = _m[0], setIsSaving = _m[1];
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    (0, react_1.useEffect)(function () {
        if (user.uid) {
            (0, get_user_details_1.get_user_details)().then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                var _a;
                var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                return __generator(this, function (_m) {
                    switch (_m.label) {
                        case 0:
                            if (!response.success) return [3 /*break*/, 2];
                            _a = setPayPointPhoneNumber;
                            return [4 /*yield*/, (0, functions_1.convert_number)((_c = (_b = response === null || response === void 0 ? void 0 : response.content) === null || _b === void 0 ? void 0 : _b.paypoint_details) === null || _c === void 0 ? void 0 : _c.phone_number)];
                        case 1:
                            _a.apply(void 0, [_m.sent()]);
                            setPoayPointPostalAdddress((_e = (_d = response === null || response === void 0 ? void 0 : response.content) === null || _d === void 0 ? void 0 : _d.paypoint_details) === null || _e === void 0 ? void 0 : _e.postal_address);
                            setPostalCode((_g = (_f = response === null || response === void 0 ? void 0 : response.content) === null || _f === void 0 ? void 0 : _f.paypoint_details) === null || _g === void 0 ? void 0 : _g.postal_code);
                            setSpouseHomeNumber((_j = (_h = response === null || response === void 0 ? void 0 : response.content) === null || _h === void 0 ? void 0 : _h.paypoint_details) === null || _j === void 0 ? void 0 : _j.physical_address);
                            setPaymaster((_l = (_k = response === null || response === void 0 ? void 0 : response.content) === null || _k === void 0 ? void 0 : _k.paypoint_details) === null || _l === void 0 ? void 0 : _l.paymaster_number);
                            return [3 /*break*/, 3];
                        case 2:
                            dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
                            _m.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); });
        }
        //
    }, [user]);
    var savePayPointDetails = function () {
        if (validateDetails()) {
            setIsSaving(true);
            var paypoint_details = {
                date_updated: new Date(),
                paymaster_number: payMaster,
                phone_number: (payPointPhoneNumber === null || payPointPhoneNumber === void 0 ? void 0 : payPointPhoneNumber.phone_number) ? payPointPhoneNumber : null,
                physical_address: payPointPhysicalAddress,
                postal_address: payPointPostalAddress,
                postal_code: postalCode,
            };
            (0, update_advanced_user_details_1.update_advanced_user_details)({
                paypoint_details: paypoint_details,
            }).then(function (response) {
                setIsSaving(false);
                if (response.success) {
                    navigate("/employment-details/banking-data");
                }
                else {
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
                }
            });
        }
    };
    var validateDetails = function () {
        var messageCount = 0;
        setPayPointPhoneNumberMessage("");
        setSpouseSurnameMessage("");
        setSpouseCellNumberMessage("");
        setPayPointPhysicalAddressMessage("");
        setPaymasterMessage("");
        if (!(payPointPhoneNumber === null || payPointPhoneNumber === void 0 ? void 0 : payPointPhoneNumber.phone_number)) {
            //  messageCount++;
            //  setPayPointPhoneNumberMessage("HR number is required.");
        }
        else {
            if (!doshx_controls_web_1.Utilities.isValidPhoneNumber(payPointPhoneNumber === null || payPointPhoneNumber === void 0 ? void 0 : payPointPhoneNumber.phone_number, payPointPhoneNumber === null || payPointPhoneNumber === void 0 ? void 0 : payPointPhoneNumber.country_abbreviation)) {
                messageCount++;
                setPayPointPhoneNumberMessage("Invalid Number.");
            }
        }
        // if (!payPointPostalAddress) {
        //   messageCount++;
        //   setSpouseSurnameMessage("HR address is required.");
        // }
        // if (!postalCode) {
        //   messageCount++;
        //   setSpouseCellNumberMessage("Postal code is required.");
        // }
        // if (!payPointPhysicalAddress) {
        //   messageCount++;
        //   setPayPointPhysicalAddressMessage("HR physical address is required.");
        // }
        // if (!payMaster) {
        //   messageCount++;
        //   setPaymasterMessage("HR is required.");
        // }
        return messageCount ? false : true;
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-8" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "flex flex-col gap-8" },
            react_1.default.createElement(page_path_1.PagePath, { path: [
                    {
                        page: "#",
                        title: "Employment Details",
                    },
                    {
                        title: "HR Details",
                        active: true,
                    },
                ] }),
            react_1.default.createElement("div", { className: "flex flex-col  gap-4" },
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "HR Details", textColor: "text-black", bold: true })),
                react_1.default.createElement("div", { className: "flex flex-col  gap-4" },
                    react_1.default.createElement(doshx_controls_web_1.PhoneInputControl, { label: "HR Phone Number", value: payPointPhoneNumber === null || payPointPhoneNumber === void 0 ? void 0 : payPointPhoneNumber.phone_number, size: "small", errorText: payPointPhoneNumberMessage, defaultCountryCode: (_a = payPointPhoneNumber === null || payPointPhoneNumber === void 0 ? void 0 : payPointPhoneNumber.country_abbreviation) !== null && _a !== void 0 ? _a : "BW", showExtension: true, showFlag: true, onChange: function (v) {
                            return setPayPointPhoneNumber(__assign(__assign({}, payPointPhoneNumber), { phone_number: v }));
                        }, onExtensionChange: function (ext, code) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                setPayPointPhoneNumber({
                                    phone_number: payPointPhoneNumber === null || payPointPhoneNumber === void 0 ? void 0 : payPointPhoneNumber.phone_number,
                                    country_code: ext,
                                    country_abbreviation: code,
                                });
                                return [2 /*return*/];
                            });
                        }); }, international: true }),
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "HR Postal Address", value: payPointPostalAddress, size: "small", errorText: payPointPostalAddressMessage, onChange: function (v) { return setPoayPointPostalAdddress(v); } }),
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Postal Code", value: postalCode, size: "small", errorText: postalCodeMessage, onChange: function (v) { return setPostalCode(v); } }),
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "HR Physical Address", value: payPointPhysicalAddress, size: "small", errorText: payPointPhysicalAddressMessage, onChange: function (v) { return setSpouseHomeNumber(v); } })),
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "HR Name", value: payMaster, size: "small", errorText: payMasterMessage, onChange: function (v) { return setPaymaster(v); } }),
                react_1.default.createElement("div", { className: "flex justify-center gap-4" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Back", backgroundColor: "bg-primary", size: "small", loading: isSaving, enabled: !isSaving, startIcon: pro_solid_svg_icons_1.faArrowLeft, onClick: function () {
                            navigate("/employment-details/employment-data");
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Save & Proceed", backgroundColor: "bg-secondary", size: "small", loading: isSaving, enabled: !isSaving, endIcon: pro_solid_svg_icons_1.faArrowRight, onClick: function () {
                            savePayPointDetails();
                        } }))))));
};
exports.PayPointDetailsPage = PayPointDetailsPage;
